export enum Perms {
    None = 'one',

    AssignmentView = 'assignment.view',
    AssignmentStore = 'assignment.store',
    AssignmentEdit = 'assignment.edit',
    AssignmentDelete = 'assignment.delete',

    CalendarView = 'calendar.view',
    CalendarStore = 'calendar.store',
    CalendarEdit = 'calendar.edit',
    CalendarDelete = 'calendar.delete',


    ConferenceDeskView = 'conferenceDesk.view',
    ConferenceDeskStore = 'conferenceDesk.store',
    ConferenceDeskEdit = 'conferenceDesk.edit',
    ConferenceDeskDelete = 'conferenceDesk.delete',

    ChatBotView = 'chatbot.view',

    CountyView = 'county.view',
    CountyStore = 'county.store',
    CountyEdit = 'county.edit',
    CountyDelete = 'county.delete',

    CourtAccess = 'court.access',
    CourtView = 'court.view',
    CourtStore = 'court.store',
    CourtEdit = 'court.edit',
    CourtDelete = 'court.delete',

    CourtEmployeeView = 'courtEmployee.view',
    CourtEmployeeStore = 'courtEmployee.store',
    CourtEmployeeEdit = 'courtEmployee.edit',
    CourtEmployeeDelete = 'courtEmployee.delete',

    DeskView = 'desk.view',
    DeskStore = 'desk.store',
    DeskEdit = 'desk.edit',
    DeskDelete = 'desk.delete',

    DeskConfView = 'deskConf.view',
    DeskConfViewAll = 'deskConf.view-all',
    DeskConfNpsView = 'deskConf.nps-view',
    DeskConfStore = 'deskConf.store',

    ScheduleConferenceView = 'scheduledConference.view',
    ScheduleConferenceViewAll = 'scheduledConference.view-all',
    ScheduleConferenceNpsView = 'scheduledConference.nps-view',
    ScheduleConferenceStore = 'scheduledConference.store',

    HearingView = 'hearing.view',
    HearingStore = 'hearing.store',
    HearingEdit = 'hearing.edit',
    HearingDelete = 'hearing.delete',
    HearingAllowChat = 'hearing.allow-chat',

    JudgeView = 'judge.view',
    JudgeStore = 'judge.store',
    JudgeEdit = 'judge.edit',
    JudgeDelete = 'judge.delete',

    LogsView = 'logs.view',

    MyCalendarView = 'my-calendar.view',

    RegionalView = 'regional.view',
    RegionalStore = 'regional.store',
    RegionalEdit = 'regional.edit',
    RegionalDelete = 'regional.delete',

    ReportView = 'reports.view',
    ReportStore = 'reports.store',
    ReportEdit = 'reports.edit',
    ReportDelete = 'reports.delete',

    RoleView = 'role.view',
    RoleStore = 'role.store',
    RoleEdit = 'role.edit',
    RoleDelete = 'role.delete',

    UserView = 'user.view',
    UserStore = 'user.store',
    UserEdit = 'user.edit',
    UserDelete = 'user.delete',
}
